import { render, staticRenderFns } from "./TrainForm.vue?vue&type=template&id=d6e1986a"
import script from "./TrainForm.vue?vue&type=script&lang=js"
export * from "./TrainForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports